
import { NavItem } from '../types';
import { LayoutDashboard, Calendar, ShieldCheck } from 'lucide-react';

const dashboardItems: NavItem[] = [
  {
    title: 'Admin Dashboard',
    icon: ShieldCheck,
    path: '/app/dashboard',
    requiredRoles: ['admin'],
  },
  {
    title: 'Dashboard',
    icon: LayoutDashboard,
    path: '/app/home',
    requiredPermissions: ['dashboard.read'],
  },
  {
    title: 'Schedule',
    icon: Calendar,
    path: '/app/schedule',
    requiredPermissions: ['schedule.read'],
  }
];

export default dashboardItems;
